import {useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const [footerLinks,setFooterLinks] = useState(
    [
      {
        title: "Student",
        items: [
          { label: "Grievance", path: "/grievances" },
          { label: "Magazine", path: "/magazine" },
          { label: "Anti Ragging", path: "/grievances?grievance=antiragging" },
          { label: "IQAC", path: "/iqac" },
        ],
      },
      {
        title: "Quick Links",
        items: [
          { label: "Tenders", path: "/announcements" },
          { label: "Careers", path: "/announcements" },
          { label: "Policies", path: "/policies" },
          { label: "NAAC", href: "http://naac.gov.in/index.php/en/" },
        ],
      },
      {
        title: "Extras",
        items: [
          { label: "RTI", path: "/right-to-information" },
          { label: "College Site Map", href: "/assets/sitemap.pdf" },
          { label: "Sitemap", path: "/sitemap.xml" },
          { label: "Location", href: 'https://maps.app.goo.gl/zwRbZqzYtC2Ri5S67' },
        ],
      },
      {
        title: "Let's Connect",
        items: [
          { label: "Facebook", path: "https://www.facebook.com" },
          { label: "Instagram", path: "https://www.instagram.com" },
          { label: "YouTube", path: "https://www.youtube.com" },
          { label: "X (Twitter)", path: "https://www.twitter.com" },
        ],
      },
    ]
  )

  // useEffect(() => {
  //   if (isMobile) {
  //     const mobileFooteLinks = footerLinks.filter(item => item.title !== "Let's Connect");
  //     setFooterLinks(mobileFooteLinks);
  //   }
  // },[])

  return (
    <footer id="nss-footer" className="min-h-[10vh] text-gray-white pt-5 px-10 bg-secondary-base">
      <div className="flex md:flex-col flex-col-reverse">
      <div className="border-b border-t border-gray-white py-4 grid md:grid-cols-5 grid-cols-2 gap-3 md:gap-0">
        {footerLinks.map((section, index) => (
          <ul key={index} className={`flex flex-col gap-2 ${index % 2 === 0 ? '':'text-right md:text-left'}`}>
            <li className="font-bold">{section.title}</li>
            <ul className="md:mt-3 mt-1 text-sm text-gray-semiWhite">
              {section.items.map((item, idx) => (
                <>
                {item?.path && <li
                  key={idx}
                  onClick={() => handleNavigation(item.path)}
                  className="cursor-pointer hover:text-gray-300 transition-colors"
                >
                  {item.label}
                </li>}
                {item?.href && 
                <a href={item.href} className="cursor-pointer hover:text-gray-300 transition-colors" >{item.label}</a>
                }
                </>
              ))}
            </ul>
          </ul>
        ))}
        <ul className="flex flex-col gap-2 text-center md:text-left col-span-2 md:col-span-1">
          <li className="font-bold">Contact Us</li>
          <a href="https://maps.app.goo.gl/zwRbZqzYtC2Ri5S67">
          <address className="md:mt-3 mt-1 text-sm text-gray-semiWhite not-italic" >
            NSS College <br />
            K.R.Puram P O Cherthala, Alappuzha (district) <br />
            PIN - 688 541 <br />
            Phone: 0478 2813226
          </address>
          </a>
        </ul>
      </div>
      <div className="border-b py-4 flex md:justify-between flex-col items-center md:flex-row md:gap-0 gap-2">
        <div className="flex gap-2 items-center">
        <img src="/logo_masked.svg" alt="NSS College Logo" className="md:w-[8em] w-[5em] object-contain" />
        <p className="w-[13em] text-xs">Affiliated to University of Kerala and NAAC Re-Accredited with <b>'A'</b> Grade</p>
        </div>
        <p className="md:text-right text-center md:w-[30%] flex flex-col md:items-end items-center">
          <div className="text-lg font-black">“सत्वात संजायते ज्ञानम”<br /></div>
          <div className="text-xs md:text-right text-center w-3/4">
            (Knowledge arises from the mode of Goodness)
            - a precept from Bhagavat Gita 14.17
          </div>
        </p>
      </div>
      </div>
      <p className="text-center text-xs py-2">
        © 1964-{new Date().getFullYear()} NSS College Cherthala
      </p>
    </footer>
  );
}
